import { createContext } from 'react'

import { ClientSession } from './utils'

interface SessionContext {
  session: ClientSession | null
  active: boolean
  loading: boolean
  error: boolean

  update(): Promise<void>
}

export const Context = createContext<SessionContext>({
  session: null,
  active: false,
  loading: false,
  error: false,
  // istanbul ignore next
  update:
    // istanbul ignore next
    (): Promise<void> => {
      // istanbul ignore next
      throw new Error('Function not implemented.')
    },
})
